import React, { useRef, useState } from 'react';
import { Wizard, Card, NotificationList } from 'quanta-ui';
import ProposerDetailsTwoWheeler from './proposer-details-two-wheeler';
import { CarPayPremium } from 'quanta-flows/modules/common/payPremium';
import ReviewConfirmDetails from './review-confirm-details';
import AdditionalDetails from './additional-details';
import VehicleDetails from './vehicleDetails';
import { Loading } from 'quanta-flows/modules/layout';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
import { GET_BUY_MOTOR_POLICY_VAR_DETAILS } from '../queries';
import { SuccessPageTW } from 'quanta-flows/modules/common/success';
// import { TransactionComponent } from 'quanta-flows';
export default function WizardPanel({
  startStep,
  isProposalCreated,
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
  stepsDisabled,
}) {
  const [successMsg, showSuccessMsg] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loadingStep, setLoadingStep] = useState(false);
  const [showWizardButtonPanel, setShowWizardButtonPanel] =
    useState(null);
  const [customLoadingMessage, setCustomLoadingMessage] =
    useState(null);
  const [proceedToNextStep, setProceedToNextStep] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [currentStepFunctions, setCurrentStepFunctions] = useState([
    null,
    null,
    null,
    null,
    null,
  ]);
  const proposerFormRef = useRef();
  const vehicleFormRef = useRef();
  const additionalDetailsRef = useRef();
  const reviewAndConfirmRef = useRef();
  const payAndPremiumRef = useRef();
  const [buttonDisable,setButtonDisable]=useState(false);

  const renderExpandedCards = useRef([
    { cardName: 'proposer customer', flag: false },
    { cardName: 'vehicle details', flag: false },
    { cardName: 'previous insurance & claims details', flag: false },
    { cardName: 'finance details', flag: false },
    { cardName: 'uploaded document', flag: false },
    { cardName: 'cheque 1', flag: true },
    { cardName: 'dd 1', flag: true },
  ]);

  const steps = [
    {
      label: 'Proposer',
      proceedLabel: () => 'Proceed',
      disableStep: stepsDisabled && stepsDisabled[0] ? true : false,
      submitForm: async () => {
        if (proposerFormRef.current) {
          const res = await proposerFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {
                  proposerFormRef?.current.errors?.proposerDetailsMeta?.isCRNVerified ?
                  proposerFormRef?.current.errors?.proposerDetailsMeta?.isCRNVerified :
                  proposerFormRef.current?.errors?.proposerDetailsMeta?.isConfigIMD ?
                  proposerFormRef.current?.errors?.proposerDetailsMeta?.isConfigIMD :
                  proposerFormRef.current?.errors?.proposerDetails?.creditScoreMsg ? 
                  proposerFormRef.current?.errors?.proposerDetails?.creditScoreMsg :
                  `Please fill the mandatory fields before proceeding.`
                  }
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading {...{ customMessage: customLoadingMessage }} />
            </div>
          ) : (
            <ProposerDetailsTwoWheeler
              forwardedRef={proposerFormRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                setParentAlerts: setAlerts,
                setLoadingStep,
                setCustomLoadingMessage,
                lobCode,
                lobName,
                productCode,
                productName,
                productType,
              }}
            />
          )
        ) : null,
    },
    {
      label: 'Vehicle',
      proceedLabel: () => 'Proceed',
      disableStep: stepsDisabled && stepsDisabled[1] ? true : false,
      submitForm: async () => {
        if (vehicleFormRef.current) {
          const res = await vehicleFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (vehicleFormRef.current) {
          updateBuyMotorPolicy({
            vehicleTabDetails: vehicleFormRef.current?.values,
          });
        }
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <Loading customMessage={customLoadingMessage} />
          ) : (
            <VehicleDetails
              forwardedRef={vehicleFormRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                setParentAlerts: setAlerts,
                lobCode,
                lobName,
                productCode,
                productName,
                productType,
              }}
            />
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {
                    vehicleFormRef?.current?.errors?.vehicleRegistrationDetails?.isProposalRegNoVerified
                    ? vehicleFormRef?.current?.errors?.vehicleRegistrationDetails?.isProposalRegNoVerified
                    : `Please fill the mandatory fields before proceeding.`
                  }
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      label: 'Additional Details',
      proceedLabel: () => 'Calculate and Proceed',
      disableStep: stepsDisabled && stepsDisabled[2] ? true : false,
      submitForm: async () => {
        if (additionalDetailsRef.current) {
          const res = await additionalDetailsRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (additionalDetailsRef.current) {
          updateBuyMotorPolicy({
            additionalTabDetails: additionalDetailsRef.current.values,
          });
        }
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <AdditionalDetails
              forwardedRef={additionalDetailsRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                setParentAlerts: setAlerts,
                setCustomLoadingMessage,
                setLoadingStep,
                setParentAlerts: setAlerts,
                productCode,
                lobCode,
                lobName,
                productName,
                productType,
              }}
            />
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full justify-center">
                <span>
                  {additionalDetailsRef?.current?.errors?.documentuploaded
                    ? additionalDetailsRef?.current?.errors?.documentuploaded
                    : `Please fill the mandatory fields before proceeding.`
                  }
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      label: 'Review & Confirm',
      proceedLabel: () =>
        isProposalCreated ? 'Proceed to Buy' : 'Create Proposal',
      disableStep: stepsDisabled && stepsDisabled[3] ? true : false,
      submitForm: async () => {
        if (reviewAndConfirmRef.current) {
          setAlerts([]);
          const res = await reviewAndConfirmRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (reviewAndConfirmRef.current) {
          updateBuyMotorPolicy({
            reviewAndConfirmTabDetails:
              reviewAndConfirmRef?.current?.values,
          });
        }
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <ReviewConfirmDetails
              forwardedRef={reviewAndConfirmRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                currentStepFunctions,
                setCurrentStepFunctions,
                setParentAlerts: setAlerts,
                setLoadingStep,
                setCustomLoadingMessage,
                productCode,
                lobCode,
                lobName,
                productName,
                productType,
                renderExpandedCards,
              }}
            />
          )
        ) : null,
    },
    {
      label: 'Pay Premium',
      proceedLabel: () => 'Submit',
      disabledLabel:  buttonDisable,
      disableStep: stepsDisabled && stepsDisabled[4] ? true : false,
      submitForm: async () => {
        setAlerts([]);
        if (payAndPremiumRef.current) {
          const res = await payAndPremiumRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (payAndPremiumRef.current) {
          updateBuyMotorPolicy({
            premiumDetails: payAndPremiumRef?.current?.values,
          });
        }
      },
      component: ({ expanded }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            // <TransactionComponent {...{ errorFlag: true }}>
            <CarPayPremium
              forwardedRef={payAndPremiumRef}
              {...{
                setLoadingStep,
                setCustomLoadingMessage,
                showSuccessMsg,
                setParentAlerts: setAlerts,
                setShowWizardButtonPanel,
                productCode,
                lobCode,
                lobName,
                productName,
                productType,
                REACTIVE_VAR_QUERY: GET_BUY_MOTOR_POLICY_VAR_DETAILS,
                updateReactiveVar: updateBuyMotorPolicy,
                reactiveVarName: 'buyMotorPolicy',
                  renderExpandedCards,
                  setButtonDisable,
                  buttonDisable,
              }}
            />
            // </TransactionComponent>
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {payAndPremiumRef.current.errors?.totalPaymentAmount
                    ? payAndPremiumRef.current.errors
                        ?.totalPaymentAmount
                    : payAndPremiumRef.current.errors?.onlinePayment
                        ?.isTransactionIdVerified
                    ? payAndPremiumRef.current.errors?.onlinePayment
                        ?.isTransactionIdVerified
                     : payAndPremiumRef.current.errors?.preinspectionDetails
                     ?.isPreInspectionVerified
                    ? `Save PreInspection Details Before Proceeding`
                    : payAndPremiumRef?.current?.errors?.cdWallet
                        ?.cdAccountCount
                    ? payAndPremiumRef?.current?.errors?.cdWallet
                        ?.cdAccountCount
                    : payAndPremiumRef.current.values
                        ?.termsAndConditions
                    ? `Please fill the mandatory fields before proceeding`
                    : 'Please fill the mandatory fields and accept terms and conditions before proceeding.'}
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  ];
  return (
    <Card
      className="min-h-screen"
      severity={`${successMsg ? 'success' : 'info'}`}
    >
      {successMsg ? (
        <SuccessPageTW
          {...{
            lobCode,
            lobName,
            productCode,
            productName,
            productType,
            REACTIVE_VAR_QUERY: GET_BUY_MOTOR_POLICY_VAR_DETAILS,
            reactiveVarName: 'buyMotorPolicy',
          }}
        />
      ) : (
        <Wizard
          {...{
            steps,
            startStep: startStep ? startStep : 0,
            tabStyle: true,
            showButtonPanel:
              showWizardButtonPanel !== null
                ? showWizardButtonPanel
                : !loadingStep,
          }}
        />
      )}
      <NotificationList
        {...{
          items: alerts,
          resetAlerts: (idx) => {
            const alertToBeRemovedPos = alerts.findIndex(
              (a) => a.id === idx,
            );
            setAlerts([
              ...alerts.slice(0, alertToBeRemovedPos),
                ...alerts.slice(
                  alertToBeRemovedPos + 1,
                  alerts.length,
                ),
            ]);
          },
        }}
      />
    </Card>
  );
}
